export default class AddGroupRegisterController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, moment,
    groups,
    studentId,
    StudentService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.moment = moment;
    this.groups = groups;
    this.studentId = studentId;
    this.StudentService = StudentService;

    this.groupRegisterRecord = {};
    this.date = new Date();
  }

  cancel() {
    this.$mdDialog.cancel();
  }

  add(form) {
    if (form.$invalid) {
      return false;
    }

    this.groupRegisterRecord.groupId = this.group.id;
    this.groupRegisterRecord.group = this.group;
    this.groupRegisterRecord.dateOfAddition = this.moment(this.date).format('YYYY-MM-DD');
    this.StudentService.addGroupsRegisterRecord(this.studentId, this.groupRegisterRecord)
      .then(() => {
        this.$mdDialog.hide();
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Zmieniono grupę')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }
}
